/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsOut: {
  name: 'arrows-out';
  data: string;
} = {
  name: 'arrows-out',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 4a1 1 0 1 0 0 2h2.586l-3.293 3.293a1 1 0 0 0 1.414 1.414L18 7.414V10a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1h-5Zm-3.293 10.707a1 1 0 0 0-1.414-1.414L6 16.586V14a1 1 0 0 0-2 0v5a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2H7.414l3.293-3.293Z" fill="currentColor"/></svg>`,
};
